import { render, staticRenderFns } from "./billing-info-v2-header.component.vue?vue&type=template&id=7e13960a&scoped=true&"
import script from "./billing-info-v2-header.component.vue?vue&type=script&lang=ts&"
export * from "./billing-info-v2-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-info-v2-header.component.vue?vue&type=style&index=0&id=7e13960a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e13960a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
